export const languageOptions = [
  { value: 'cn', label: ' Chinese', symbol: '🇨🇳', title: 'China' },
  { value: 'en', label: ' English', symbol: '🇺🇸', title: 'USA' },
  { value: 'es', label: ' Spanish', symbol: '🇪🇸', title: 'Spain' },
  { value: 'kr', label: ' Korean', symbol: '🇰🇷', title: 'Korea' },
  { value: 'jp', label: ' Japanese', symbol: '🇯🇵', title: 'Japan' },
  { value: 'dk', label: ' Danish', symbol: '🇩🇰', title: 'Denmark' },
]
